import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Card, CardActionArea, CardContent, Typography } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  cardItem: {
    width: 160,
    borderRadius: theme.shape.borderRadius * 1.5,
    transition: 'transform 0.2s, box-shadow 0.2s, border-color 0.2s',
    border: `1px solid ${theme.palette.grey[300]}`,
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: theme.shadows[4],
    },
  },
  selected: {
    border: `2px solid ${theme.palette.primary.main}`,
    boxShadow: theme.shadows[6],
  },
  media1: {
    width: '100%',
    height: 140,
    objectFit: 'cover',
    borderTopLeftRadius: theme.shape.borderRadius * 1.5,
    borderTopRightRadius: theme.shape.borderRadius * 1.5,
  },
  media: {
    width: 160,
    height: 100, // height < width → rectangle
    objectFit: 'cover',
    display: 'block',
    margin: '0 auto',
  },
  
  content: {
    textAlign: 'center',
    padding: theme.spacing(1.5),
  },
}));


const DocumentGrid = ({ documents, placeholderImage, onDocumentClick, selectedDoc }) => {
  const classes = useStyles();

  return (
    <>
      {documents.map((doc) => {
        const isSelected = selectedDoc === doc.id;

        return (
          <Grid item key={doc.id} xs="auto">
            <Tooltip title={doc.name} arrow>
            <Card
              className={`${classes.cardItem} ${isSelected ? classes.selected : ''}`}
            >
              <CardActionArea onClick={() => onDocumentClick(doc)}>
                <img
                  src={placeholderImage}
                  alt="Document Preview"
                  className={classes.media}
                />
                <CardContent className={classes.content}>
                  <Typography variant="subtitle1" noWrap>
                    {doc.name}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    ID: {doc.id}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
            </Tooltip>
            
          </Grid>
        );
      })}
    </>
  );
};

export default DocumentGrid;